export default "__VITE_ASSET__DP1P6mRL__"